import React from 'react';
import GPSelectMultiple from './SelectMultiple';
import GPSearchableSelectMultiple from './SearchableSelectMultiple';

export default function AutoSelectMultiple(props?: IGPBaseSelectMultipleProps) {
  const { searchable = false, onChange, ...restProps } = props || {};

  if (searchable) return <GPSearchableSelectMultiple onChange={onChange} {...restProps} />;
  return <GPSelectMultiple onChange={onChange} {...restProps} />;
}
